import { Routes, Route } from "react-router-dom";

// Auth Pages
import SignIn from "../pages/SignIn";
import SignUp from "../pages/SignUp";
import ForgetPassword from "../pages/ForgetPassword";
import OtpVerification from "../pages/OtpVerification";
import AdminLogin from "../Admin/Pages/AdminLogin";
import AdminSignUp from "../Admin/Pages/AdminSignUp";
import SearchEmail from "../pages/SearchEmail";

// Public Pages
import LandingPage from "../pages/LandingPage";
import AboutPage from "../pages/AboutPage";
import SupportPage from "../pages/SupportPage";
import ContactUsPage from "../pages/ContactUsPage";
import PageNotFound from "../pages/PageNotFound";
import TermsAndConditions from "../pages/TermsAndConditions";
import TermAndConditionForSubscription from "../pages/TermAndConditionForSubscription";

// Payment Pages
import PaymentCancel from "../pages/PaymentCancel";
import PaymentSuccess from "../pages/PaymentSuccess";
import PaymentStatus from "../components/PaymentStatus";

// User Dashboard Pages
import HomePage from "../pages/HomePage";
import Project from "../pages/Project";
import CreateProject from "../pages/CreateProject";
import UserFLowTable from "../components/userFlowTable/UserFlowTable";

// Project Management
import EditCreateProject from "../components/createProject/EditCreateProject";
import Calendar from "../components/projects/Calendar";
import Invite from "../components/createProject/Invite";
import VolumePage from "../components/createProject/volumeBased";
import { RentalBasePage } from "../components/createProject/RentalBase/RentalBasePage";
import ScaffoldPricing from "../components/createProject/PricePage/ScaffoldPricing";

// Subscription Pages
import SubscriptionPageDetails from "../pages/SubscriptionPageDetails";
import MySubscriptionPlanDetail from "../pages/MySubscriptionPlanDetail";

// Form Pages
import Forms from "../pages/Forms";
import ServiceForms from "../pages/ServiceForms";
import ServicesPage from "../pages/ServicesPage";
import EditApprovalForm from "../components/forms/EditApprovalForm";
import ApprovalFormPdf from "../components/forms/ApprovalFormPdf";
import ApprovalFormPdfTemplate from "../pages/ApprovalFormPdfTemplate";
import ApprovalListingPage from "../pages/ApprovalListingPage";

// After Control Forms
import AfterControl from "../components/forms/AfterControl";
import AfterControlForm from "../components/forms/AfterControlForm";
import EditAfterControl from "../components/forms/EditAfterControl";
import EditAfterControlForm from "../components/forms/EditAfterControlForm";
import AfterControlFormListingPage from "../components/forms/AfterControlFormListingPage";
import AfterControlFormPdfTemplate from "../pages/AfterControlFormPdfTemplate";

// Material List Pages
import MaterialList from "../pages/MaterialList";
import EditMaterialList from "../pages/EditMaterialList";
import MaterialListingPage from "../pages/MaterialListingPage";

// Safe Job Analysis Pages
import SafeJobAnalysisForm from "../pages/SafeJobAnalysisForm";
import EditSafeJobAnalysis from "../pages/EditSafeJobAnalysis";
import SafeJobAnalysisListing from "../pages/SafeJobAnalysisListing";
import SafeJobAnalysisPdf from "../pages/SafeJobAnalysisPdf";

// Observation Pages
import ObservationForm from "../pages/ObservationForm";
import ObservationListing from "../pages/ObservationListingPage";
import EditObservationListing from "../pages/EditObservationListing";
import ObservationPdf from "../pages/ObservationPdf";

// File & Media Pages
import FilesPage from "../pages/FilesPage";
import PicturesPage from "../pages/PicturesPage";

// Admin Dashboard - Main
import AdminDashboard from "../Admin/Pages/AdminDashboard";
import DashboardHomePage from "../Admin/Pages/DashboardHomePage";
import NewAdminDashboard from "../new-admin/app/AdminDashboard";

// Admin Dashboard - User Management
import Users from "../Admin/Pages/Users";
import AllUsers from "../Admin/Pages/AllUsers";
import AllAdmin from "../Admin/Pages/AllAdmin";
import AddNewUserFormPage from "../Admin/Pages/AddNewUserFormPage";
import ViewUsersDetails from "../Admin/Pages/ViewUsersDetails";
import VisitorList from "../Admin/Pages/VisitorList";
import UserInvitePage from "../new-admin/pages/users-access/user-invite-page";
import { UserInviteForm } from "../new-admin/pages/users-access/user-invite-form";
import AdminManagementIndex from "../new-admin/pages/admin-management";

// Admin Dashboard - Project Management
import AllProjects from "../Admin/Pages/AllProjects";
import ViewProjectDetails from "../Admin/Pages/ViewProjectDetails";
import InviteUserForProject from "../Admin/Pages/InviteUserForProject";
import InvitedUserForProject from "../Admin/Pages/InvitedUserForProject";
import ProjectsPage from "../new-admin/pages/projects";
import ProjectForm from "../new-admin/pages/projects/components/create-new-project";
import EditProjectPage from "../new-admin/pages/projects/components/edit-project-page";
import ProjectView from "../new-admin/pages/projects/components/project-view";
import ProjectLogPage from "../new-admin/pages/project-log/project-log-page";
import ProjectLogPageDetails from "../new-admin/pages/project-log/page";

// Admin Dashboard - Forms Management
import AllForms from "../Admin/Pages/AllForms";
import ApprovalForms from "../Admin/Pages/ApprovalForm";
import ObservationForms from "../Admin/Pages/ObservationForm";
import SjaForms from "../Admin/Pages/SjaForm";
import MaterialListForms from "../Admin/Pages/MaterialListForm";
import AfterControlForms from "../Admin/Pages/AfterControlForm";

// Admin Dashboard - New UI Forms
import ApprovalPage from "../new-admin/pages/approvals/page";
import ApprovalForm from "../new-admin/pages/approvals/components/create-new-approval-form";
import ApprovalFormView from "../new-admin/pages/approvals/components/approval-form-view";
import ApprovalEditPage from "../new-admin/pages/approvals/components/approval-edit-page";

// Admin Dashboard - New UI SJA
import SjaPage from "../new-admin/pages/sja/sja";
import SafeJobAnalysisPage from "../new-admin/pages/sja/components/sja-create-page";
import EditSafeJobAnalysisPage from "../new-admin/pages/sja/components/sja-edit-page";
import SafeJobAnalysisDetailPage from "../new-admin/pages/sja/components/sja-detail-page";

// Admin Dashboard - New UI Observations
import AdminObservation from "../new-admin/pages/observations";
import ObservationFormPage from "../new-admin/pages/observations/components/observation-create-form";
import ObservationEdigPage from "../new-admin/pages/observations/components/observation-edit-page";
import ObservationDetails from "../new-admin/pages/observations/components/observation-view-page";

// Admin Dashboard - New UI Material List
import MaterialListPage from "../new-admin/pages/material-list";
import CreateMaterialistPage from "../new-admin/pages/material-list/components/create-material-list-page";
import EditMaterialListPage from "../new-admin/pages/material-list/components/edit-material-list-page";
import MaterialListView from "../new-admin/pages/material-list/components/material-list-view";

// Admin Dashboard - After Control
import AfterControlIndex from "../new-admin/pages/after-control";
import CreateAfterControlForm from "../new-admin/pages/after-control/components/create-after-control-form";

// Admin Dashboard - Time Tracking & Lists
import TimeTracking from "../new-admin/pages/time-tracking";
import TimeListAdminIndex from "../new-admin/pages/time-list";
import TimeEntryForm from "../new-admin/pages/time-list/components/TimeEntryForm";
import EditTimeListForm from "../new-admin/pages/time-list/components/edit-time-list";

// Admin Dashboard - Subscription
import SubscriptionList from "../Admin/Pages/SubscriptionList";
import SubscriptionPage from "../new-admin/pages/subscriptions/SubscriptionPage";

// Route Protection
import PrivateRoute from "./PrivateRoutes";
import ViewAfterControlForm from "../new-admin/pages/after-control/components/view-after-control-form";
import NotificationIndex from "../new-admin/pages/notification";
import AdminSubscriptionIndex from "../new-admin/pages/my-subscription";
import ProfileIndex from "../new-admin/pages/profile/components/ProfilePage";
import InventoryIndex from "../new-admin/pages/inventory";
import TransferMaterialIndex from "../new-admin/pages/transfer-materials";

const AllRoutes = () => {
  return (
    <Routes>
      {/* =============== PUBLIC ROUTES =============== */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/*" element={<PageNotFound />} />
      
      {/* Authentication Routes */}
      <Route path="/signin" element={<SignIn />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/forget-password" element={<ForgetPassword />} />
      <Route path="/otp-verification" element={<OtpVerification />} />
      <Route path="/admin-login" element={<AdminLogin />} />
      <Route path="/admin-signup" element={<AdminSignUp />} />
      <Route path="/search-email" element={<SearchEmail />} />
      
      {/* Information Pages */}
      <Route path="/about-us" element={<AboutPage />} />
      <Route path="/support" element={<SupportPage />} />
      <Route path="/contact-us" element={<ContactUsPage />} />
      <Route path="/terms-and-conditions-summary" element={<TermsAndConditions />} />
      <Route path="/term-and-condition" element={<TermAndConditionForSubscription />} />
      
      {/* Payment Routes */}
      <Route path="/cancel" element={<PaymentCancel />} />
      <Route path="/success" element={<PaymentSuccess />} />
      <Route path="/payment-status" element={<PaymentStatus />} />
      
      {/* Subscription Routes */}
      <Route path="/subscription" element={<SubscriptionPageDetails />} />
      <Route path="/my-subscription" element={<MySubscriptionPlanDetail />} />
      
      {/* Project Invitation */}
      <Route path="/project/invite/:id/:status/:userid/:type/:projectId" element={<Invite />} />
      
      {/* Public Views of Forms */}
      <Route path="/calendar/:id" element={<Calendar />} />
      <Route path="/approval-form-pdf/:id" element={<ApprovalFormPdf />} />
      <Route path="/observation-pdf/:projectId/:observationId" element={<ObservationPdf />} />
      <Route path="/safe-job-analysis-pdf/:projectId/:safeJobAnalysisId" element={<SafeJobAnalysisPdf />} />
      <Route path="/user-flow" element={<UserFLowTable />} />

      {/* =============== PRIVATE ROUTES (USER) =============== */}
      
      {/* Dashboard */}
      <Route
        path="/home"
        element={
          <PrivateRoute>
            <HomePage />
          </PrivateRoute>
        }
      />
      
      {/* Project Management */}
      <Route
        path="/create-project"
        element={
          <PrivateRoute path="/create-project">
            <CreateProject />
          </PrivateRoute>
        }
      />
      <Route
        path="/project"
        element={
          <PrivateRoute path="/project">
            <Project />
          </PrivateRoute>
        }
      />
      <Route
        path="/edit-create-project/:id"
        element={
          <PrivateRoute>
            <EditCreateProject />
          </PrivateRoute>
        }
      />
      <Route
        path="/volume/:projectId"
        element={
          <PrivateRoute>
            <VolumePage />
          </PrivateRoute>
        }
      />
      <Route
        path="/rental/:projectId"
        element={
          <PrivateRoute>
            <RentalBasePage />
          </PrivateRoute>
        }
      />
      <Route
        path="/price/:projectId"
        element={
          <PrivateRoute>
            <ScaffoldPricing />
          </PrivateRoute>
        }
      />
      
      {/* Services */}
      <Route
        path="/servicesforms"
        element={
          <PrivateRoute>
            <ServiceForms />
          </PrivateRoute>
        }
      />
      <Route
        path="/services"
        element={
          <PrivateRoute>
            <ServicesPage />
          </PrivateRoute>
        }
      />
      
      {/* Files and Pictures */}
      <Route
        path="/files/:projectId"
        element={
          <PrivateRoute>
            <FilesPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/pictures/:projectId"
        element={
          <PrivateRoute>
            <PicturesPage />
          </PrivateRoute>
        }
      />
      
      {/* Approval Forms */}
      <Route
        path="/approval-form/:id"
        element={
          <PrivateRoute>
            <Forms />
          </PrivateRoute>
        }
      />
      <Route
        path="/edit-approval-form/:id"
        element={
          <PrivateRoute>
            <EditApprovalForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/approval-listing-page/:id"
        element={
          <PrivateRoute>
            <ApprovalListingPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/approval-form/pdf/:approvalId"
        element={
          <PrivateRoute>
            <ApprovalFormPdfTemplate />
          </PrivateRoute>
        }
      />
      
      {/* After Control Forms */}
      <Route
        path="/after-control-form/:id"
        element={
          <PrivateRoute>
            <AfterControlForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/control-form-after/:id"
        element={
          <PrivateRoute>
            <AfterControl />
          </PrivateRoute>
        }
      />
      <Route
        path="/after-control-listing-form/:id"
        element={
          <PrivateRoute>
            <AfterControlFormListingPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/edit-control-form-after/:projectId/:afterControlId"
        element={
          <PrivateRoute>
            <EditAfterControl />
          </PrivateRoute>
        }
      />
      <Route
        path="/edit-after-control-listing-form/:approvalId/:controlFormId"
        element={
          <PrivateRoute>
            <EditAfterControlForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/after-control-form/pdf/:id"
        element={
          <PrivateRoute>
            <AfterControlFormPdfTemplate />
          </PrivateRoute>
        }
      />
      
      {/* Material Lists */}
      <Route
        path="/material-list/:projectId"
        element={
          <PrivateRoute>
            <MaterialList />
          </PrivateRoute>
        }
      />
      <Route
        path="/edit-material-list/:projectId/:materialId"
        element={
          <PrivateRoute>
            <EditMaterialList />
          </PrivateRoute>
        }
      />
      <Route
        path="/material-listing-page/:projectId"
        element={
          <PrivateRoute>
            <MaterialListingPage />
          </PrivateRoute>
        }
      />
      
      {/* Safe Job Analysis */}
      <Route
        path="/safe-job-analysis/:projectId"
        element={
          <PrivateRoute>
            <SafeJobAnalysisForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/safe-job-analysis-listing/:projectId"
        element={
          <PrivateRoute>
            <SafeJobAnalysisListing />
          </PrivateRoute>
        }
      />
      <Route
        path="/edit-safe-job-analysis/:projectId/:safeJobAnalysisId"
        element={
          <PrivateRoute>
            <EditSafeJobAnalysis />
          </PrivateRoute>
        }
      />
      
      {/* Observation Forms */}
      <Route
        path="/observation/:projectId"
        element={
          <PrivateRoute>
            <ObservationForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/observation-listing/:projectId"
        element={
          <PrivateRoute>
            <ObservationListing />
          </PrivateRoute>
        }
      />
      <Route
        path="/edit-Observation-listing/:projectId/:observationId"
        element={
          <PrivateRoute>
            <EditObservationListing />
          </PrivateRoute>
        }
      />

      {/* =============== ADMIN DASHBOARD ROUTES =============== */}
      
      {/* Admin Dashboard - Main */}
      <Route path="/admin-dashboard" element={<AdminDashboard />} />
      <Route path="/admin-dashboard/home-page" element={<DashboardHomePage />} />
      <Route path="/new-admin-dashboard" element={<NewAdminDashboard />} />
      <Route path="/new-admin-dashboard/user-profile" element={<ProfileIndex />} />
      <Route path="/admin/inventory" element={<InventoryIndex />} />
      <Route path="/admin/transfer-material" element={<TransferMaterialIndex />} />
      
      {/* Admin Dashboard - User Management */}
      <Route path="/admin-dashboard/user/users" element={<Users />} />
      <Route path="/admin-dashboard/user/all-users" element={<AllUsers />} />
      <Route path="/admin-dashboard/user/all-admin" element={<AllAdmin />} />
      <Route path="/admin-dashboard/user/add-new-user" element={<AddNewUserFormPage />} />
      <Route path="/admin-dashboard/user/view-user-details/:id" element={<ViewUsersDetails />} />
      <Route path="/admin-dashboard/visitor" element={<VisitorList />} />
      <Route path="/admin/users-access" element={<UserInvitePage />} />
      <Route path="/admin/users-access/user-invite" element={<UserInviteForm />} />
      <Route path="/admin/admin-management" element={<AdminManagementIndex />} />

       {/* Admin Dashboard - Subscription */}
        <Route path="/admin/admin-subscription" element={<AdminSubscriptionIndex />} />
      
      {/* Admin Dashboard - Project Management */}
      <Route path="/admin-dashboard/project/all-projects" element={<AllProjects />} />
      <Route path="/admin-dashboard/project/invite-user" element={<InviteUserForProject />} />
      <Route path="/admin-dashboard/project/invited-user" element={<InvitedUserForProject />} />
      <Route path="/admin-dashboard/user/view-project-details/:projectDetail" element={<ViewProjectDetails />} />
      <Route path="/admin/projects" element={<ProjectsPage />} />
      <Route path="/admin/project/create-new-project" element={<ProjectForm />} />
      <Route path="/admin/projects/edit-project/:projectId" element={<EditProjectPage />} />
      <Route path="/admin/projects/view/:projectId" element={<ProjectView />} />
      <Route path="/admin/project-log-page" element={<ProjectLogPage />} />
      <Route path="/admin/project-log-page/:projectId" element={<ProjectLogPageDetails />} />
      
      {/* Admin Dashboard - Forms Management */}
      <Route path="/admin-dashboard/form/all-forms" element={<AllForms />} />
      <Route path="/admin-dashboard/form/approval-forms" element={<ApprovalForms />} />
      <Route path="/admin-dashboard/form/observation-forms" element={<ObservationForms />} />
      <Route path="/admin-dashboard/form/SJA-forms" element={<SjaForms />} />
      <Route path="/admin-dashboard/form/material-list-forms" element={<MaterialListForms />} />
      <Route path="/admin-dashboard/form/after-control-forms" element={<AfterControlForms />} />
      
      {/* Admin Dashboard - New UI Approval Forms */}
      <Route path="/admin/approval-form" element={<ApprovalPage />} />
      <Route path="/admin/approval-form/create-approval-form" element={<ApprovalForm />} />
      <Route path="/admin/approval-form/approval-view-page/:approvalId" element={<ApprovalFormView />} />
      <Route path="/admin/approval-form/approval-edit-page/:approvalId" element={<ApprovalEditPage />} />
      
      {/* Admin Dashboard - New UI Safe Job Analysis */}
      <Route path="/admin/sja" element={<SjaPage />} />
      <Route path="/admin/sja/create-page" element={<SafeJobAnalysisPage />} />
      <Route path="/admin/sja/edit-page/:projectId/:safeJobAnalysisId" element={<EditSafeJobAnalysisPage />} />
      <Route path="/admin/sja/detail-page/:sjaId" element={<SafeJobAnalysisDetailPage />} />
      
      {/* Admin Dashboard - New UI Observations */}
      <Route path="/admin/observations" element={<AdminObservation />} />
      <Route path="/admin/observations/observation-create-page" element={<ObservationFormPage />} />
      <Route path="/admin/observations/observation-edit-page/:projectId/:observationId" element={<ObservationEdigPage />} />
      <Route path="/admin/observations/observation-detail-page/:observationId" element={<ObservationDetails />} />
      
      {/* Admin Dashboard - New UI Material List */}
      <Route path="/admin/material-list" element={<MaterialListPage />} />
      <Route path="/admin/material-list/create-material-list-page" element={<CreateMaterialistPage />} />
      <Route path="/admin/material-list/edit-material-list-page/:projectId/:materialId" element={<EditMaterialListPage />} />
      <Route path="/admin/material-list/material-list-detail-page/:materialId" element={<MaterialListView />} />
      
      {/* Admin Dashboard - New UI After Control */}
      <Route path="/admin/after-control" element={<AfterControlIndex />} />
      <Route path="/admin/create-after-control" element={<CreateAfterControlForm />} />
      <Route path="/admin/view-after-control-form/:projectId/:afterControlId" element={<ViewAfterControlForm />} />
      
      {/* Admin Dashboard - Time Tracking & Lists */}
      <Route path="/admin/time-tracking" element={<TimeTracking />} />
      <Route path="/admin/time-track-list" element={<TimeListAdminIndex />} />
      <Route path="/admin/time-entry/:projectId" element={<TimeEntryForm />} />
      <Route path="/admin/edit-time-entry/:projectId/:entryId" element={<EditTimeListForm />} />
      
      {/* Admin Dashboard - Subscriptions */}
      <Route path="/admin-dashboard/subscription-list-forms" element={<SubscriptionList />} />
      <Route path="/admin/subscription" element={<SubscriptionPage />} />
      
     {/* Admin Dashboard - Notification*/}      
      <Route path="/admin/notification" element={<NotificationIndex />} />

    </Routes>
  );
};

export default AllRoutes;